module.exports = __webpack_public_path__ + "img/hand_with_clock.db9b412d.png";